export default __webpack_public_path__ + "static/media/metalingots.f1a31277.png";